module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15uLWGy/tc-custom/9781460334003.jpg?1726617321465",
      "alt": "This image is the cover for the book Safe Harbor, Ladera by the Sea"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Safe Harbor, Ladera by the Sea\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_c('b', [_vm._v("If he stays, she's in danger. But if he leaves ")])]), _c('br'), _c('br'), _vm._v("All Mike Ryan can tell her is his name. Revealing any more to this beautiful stranger would put her in danger. And he's not willing to jeopardize Stevi Roman'sor her family'ssafety any more than he already has. Why this angel has taken him in, nursed him and trusted him, he can't fathom. But it has been the best few weeks he's ever known. For the first time, Mike can imagine having a real life, a real identity, a real future. Stevi has done more than save him. She's inspired him. "), _c('br'), _c('br'), _vm._v("And that's why he has to go. The safest thing he could do for all of them is to disappear.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marie Ferrarella\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("This USA TODAY bestselling and RITA ® Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0